import { FIELDS_STEPS_MAPING } from '@app/configs/solvencyDeclaration';
const getStepFields = (questionnaireForm, step) => Object.keys(FIELDS_STEPS_MAPING)
    .filter((field) => FIELDS_STEPS_MAPING[field] === step)
    .map((field) => questionnaireForm === null || questionnaireForm === void 0 ? void 0 : questionnaireForm[field])
    .filter(Boolean);
const buildChildToParentMap = (fields) => {
    const map = new Map();
    fields.forEach((field) => {
        if (field.reqif) {
            map.set(field.name, field.reqif.split('=')[0]);
        }
        else if (field.group) {
            map.set(field.name, field.group);
        }
    });
    return map;
};
export const getRootParent = (name, childToParent, visited = new Set()) => {
    if (visited.has(name))
        return name;
    visited.add(name);
    const parent = childToParent.get(name);
    return parent ? getRootParent(parent, childToParent, visited) : name;
};
export const isFieldVisible = (field, questionnaireForm, watch) => {
    var _a;
    if (!field.reqif)
        return true;
    const [dependentField, value] = field.reqif.split('=');
    const checkValue = ((_a = questionnaireForm === null || questionnaireForm === void 0 ? void 0 : questionnaireForm[dependentField]) === null || _a === void 0 ? void 0 : _a.type) === 'checkbox' ? true : value;
    return watch(dependentField) === checkValue;
};
export const buildSections = (questionnaireForm, step, watch) => {
    if (!questionnaireForm || !Object.keys(questionnaireForm).length)
        return [];
    const stepFields = getStepFields(questionnaireForm, step);
    const childToParent = buildChildToParentMap(stepFields);
    const visibleFields = stepFields.filter((field) => isFieldVisible(field, questionnaireForm, watch));
    const rootOrder = [];
    const groups = new Map();
    visibleFields.forEach((field) => {
        const root = getRootParent(field.name, childToParent);
        if (!groups.has(root)) {
            rootOrder.push(root);
            groups.set(root, []);
        }
        groups.get(root).push(field);
    });
    return rootOrder.map((rootName) => {
        var _a;
        return ({
            fields: groups.get(rootName),
            description: (_a = questionnaireForm === null || questionnaireForm === void 0 ? void 0 : questionnaireForm[rootName]) === null || _a === void 0 ? void 0 : _a.description,
        });
    });
};
